import { motion } from "framer-motion";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Features from "@/components/Features";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import Pricing from "@/components/Pricing";
import ExtendedHoursCTA from "@/components/ExtendedHoursCTA";
import FAQ from "@/components/FAQ";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" as const } },
};

const Section = ({ children }: { children: React.ReactNode }) => (
  <motion.div
    variants={fadeUp}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.15 }}
  >
    {children}
  </motion.div>
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Section><Hero /></Section>
        <Section><Features /></Section>
        <Section><Testimonials /></Section>
        <Section><HowItWorks /></Section>
        <Section><Pricing /></Section>
        <Section><ExtendedHoursCTA /></Section>
        <Section><FAQ /></Section>
        <Section><CTA /></Section>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
